/* @flow */
import * as React from 'react';

import ModalStatusContext from '../context/ModalStatusContext';
import type { ModalStatusContextProps } from '../context/ModalStatusContext';

export default function useModalStatusContext(): ModalStatusContextProps {
  const context = React.useContext(ModalStatusContext);
  return context;
}
